import { render, staticRenderFns } from "./UserEditAddressDetails.vue?vue&type=template&id=ec2ca440&scoped=true&"
import script from "./UserEditAddressDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditAddressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2ca440",
  null
  
)

export default component.exports